import { types as ActionTypes } from './AuthenticatorCode.actions';
import { genericReducer } from '../../helpers/ReduxHelpers';

export const initialState = {
    error: null,
    qrCode: null,
    qrUri: null,
    isLoading: false,
};

export default genericReducer(initialState, {
    [ActionTypes.generateCodeBegin]: state => ({
        ...state,
        error: initialState.error,
        isLoading: true,
    }),

    [ActionTypes.generateCodeFailure]: (state, error) => ({
        ...state,
        qrCode: initialState.qrCode,
        qrUri: initialState.qrUri,
        error,
        isLoading: false,
    }),

    [ActionTypes.generateCodeSuccess]: (state, { issuer = 'Osano', qrCode, userId }) => {
        return {
            ...state,
            qrCode,
            qrUri: `otpauth://totp/${encodeURIComponent(userId)}?secret=${qrCode}&issuer=${encodeURIComponent(issuer)}`,
            error: initialState.error,
            isLoading: false,
        };
    },
});
